import { render } from "./McpAppRenderer.vue?vue&type=template&id=a9af0a58&scoped=true"
import script from "./McpAppRenderer.vue?vue&type=script&lang=js"
export * from "./McpAppRenderer.vue?vue&type=script&lang=js"

import "./McpAppRenderer.vue?vue&type=style&index=0&id=a9af0a58&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9af0a58"]])

export default __exports__